import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Notification from './components/Notification';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import CountryPage from './pages/CountryPage';
import { Australia } from './countries/Australia';
import { Canada } from './countries/Canada';
import { Denmark } from './countries/Denmark';
import { Finland } from './countries/Finland';
import { Ireland } from './countries/Ireland';
import { NewYork } from './countries/NewYork';
import { NewZealand } from './countries/NewZealand';
import { Sweden } from './countries/Sweden';
import { UK } from './countries/UK';
import ScholarshipForm from './components/ScholarshipForm';
import NewsPage from './pages/NewsPage';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Notification />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/country/australia" element={<CountryPage country={Australia}/>} />
          <Route path="/country/canada" element={<CountryPage country={Canada}/>} />
          <Route path="/country/denmark" element={<CountryPage country={Denmark}/>} />
          <Route path="/country/finland" element={<CountryPage country={Finland}/>} />
          <Route path="/country/ireland" element={<CountryPage country={Ireland}/>} />
          <Route path="/country/new-york" element={<CountryPage country={NewYork}/>} />
          <Route path="/country/new-zealand" element={<CountryPage country={NewZealand}/>} />
          <Route path="/country/sweden" element={<CountryPage country={Sweden}/>} />
          <Route path="/country/uk" element={<CountryPage country={UK}/>} />
          <Route path="/apply" element={<ScholarshipForm />} />
          <Route path="/news/:id" element={<NewsPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
